import tippy from 'tippy.js';

export default function () {


    const useRwdButton = document.querySelector('.use-rwd-toggle')

    if (!useRwdButton) return;

    useRwdButton.addEventListener('click', function () {
        const rwdEnabled = document.body.getAttribute('data-admin-rwd-enabled');

        if (rwdEnabled === null) {
            Cookies.set('admin-rwd-enabled', '1', { expires: 365 });
            location.reload();
        } else {
            Cookies.remove('admin-rwd-enabled');
            location.reload();
        }
    });

    const rwdMenuTrigger = document.querySelector('.rwd-menu-trigger');

    if (rwdMenuTrigger) {
        rwdMenuTrigger.addEventListener('click', function () {
            document.body.classList.toggle('show-rwd-menu');
        });

        const rwdMenuBackdrop = document.querySelector('.rwd-menu-backdrop');

        rwdMenuBackdrop.addEventListener('click', function () {
            document.body.classList.remove('show-rwd-menu');
        });
    }

    // FILTERS
    const filterContainers = document.querySelectorAll('filter-container');

    filterContainers.forEach(filterContainer => {
        const filterRwdTrigger = document.createElement('button');
        filterRwdTrigger.setAttribute('type', 'button');
        filterRwdTrigger.textContent = 'Filtry';
        filterRwdTrigger.classList.add('filter-rwd-trigger', 'button');

        const filterCloseButton = document.createElement('button');
        filterCloseButton.setAttribute('type', 'button');
        filterCloseButton.classList.add('filter-close-button');

        filterContainer.insertAdjacentElement('beforebegin', filterRwdTrigger);
        filterContainer.insertAdjacentElement('afterbegin', filterCloseButton);

        filterRwdTrigger.addEventListener('click', function () {
            this.classList.toggle('show-filters');
        });

        filterCloseButton.addEventListener('click', function () {
            filterRwdTrigger.classList.remove('show-filters');
        });

        const appliedFilters = [
            ...Array.from(filterContainer.querySelectorAll('input[type="text"]')).filter(input => input.value != ''),
            ...Array.from(filterContainer.querySelectorAll('select')).filter(select => {
                const allOptions = Array.from(select.querySelectorAll('option[selected]'));

                const filtered = allOptions.filter(option => {
                    return option.getAttribute('value') !== '-1';
                });

                return filtered.length > 0;
            }),
            ...Array.from(filterContainer.querySelectorAll('input[type="checkbox"]:checked'))
        ];

        filterRwdTrigger.setAttribute('data-active-filters', appliedFilters.length);
    });

    // TABLES
    const defaultTable = document.querySelector('.default-table');

    if (defaultTable) {
        const rows = defaultTable.querySelectorAll('.grid-row');

        const gridHeader = defaultTable.querySelector('.grid-header');
        const titlesArray = [];

        if (gridHeader) {
            gridHeader.querySelectorAll('th').forEach(th => {
                titlesArray.push(th.textContent.trim());
            });
        }

        rows.forEach(row => {
            const toggleButton = document.createElement('button');
            toggleButton.setAttribute('type', 'button');
            toggleButton.classList.add('grid-row-toggler');

            row.insertAdjacentElement('beforeend', toggleButton);

            toggleButton.addEventListener('click', function () {
                row.classList.toggle('show-hidden');
            });

            if (titlesArray.length > 0) {
                row.querySelectorAll('td').forEach((td, index) => td.setAttribute('data-name', titlesArray[index]));
            }
        });
    }
}